import {
  API_V1_GET_ROLES
} from './constants'
import {
  serviceAccountErrorCallback,
  serviceAccountSuccessCallback
} from 'api/callbacks'

export function getRolesV1 ({params}) {
  return axios.get(API_V1_GET_ROLES, {withCredentials: false, params})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}



// WEBPACK FOOTER //
// ./app/api/roles/roles.js